export default "__VITE_ASSET__DrHcgctP__"